import React from 'react';
import styled from 'styled-components';
import { useAppSelector, configSelectors, } from '@pomofocus/shared-client';
import { IconSets } from '../../common/IconSets';
import { ButtonText } from '../../styles/Button';
import { Form } from '../../styles/Form';
import Selections from '../../common/Selections';
import { NT_SELECTIONS } from '../../../constants';
import { WebPushSubList } from '../../config/WebPushSubList';
import { SectionWrapper, FormBlock, FormHeader, FormHeaderText, FlexWrapper, InfoTipWrapper, InfoTip, } from './common';
export const NotificationConfig = ({ handleSelectNotificationType, handleChangeNotificationMinutes, onClickCrossDeviceInfo, onClickAddWebpush, handleClickWebPushTest, webpushSubs, updateWebPushSub, removeWebPushSub, }) => {
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    return (React.createElement(SectionWrapper, { subHeader: "Notification", SubHeaderIcon: React.createElement(IconSets, { name: "Bell" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Reminder")),
                React.createElement(NotificationWrapper, null,
                    React.createElement(Selections, { selectedId: configObj.notificationType, handleSelect: handleSelectNotificationType, selection: NT_SELECTIONS, idAttr: "id", textAttr: "text", width: 80, fontSize: 14 }),
                    React.createElement(NotificationMinuteForm, { value: configObj.notificationMinutes, onChange: (e) => handleChangeNotificationMinutes(Math.floor(e.target.value)), type: "number", min: "1", step: "1" }),
                    "min"))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null,
                        "Mobile Alarm",
                        React.createElement(InfoTipWrapper, { onClick: onClickCrossDeviceInfo },
                            React.createElement(InfoTip, { src: "/icons/information-black2.png" })))),
                React.createElement(NotificationWrapper, null,
                    React.createElement(GrayButton, { onClick: onClickAddWebpush }, "+ Add this device"))),
            React.createElement(WebPushSubList, { webpushSubs: webpushSubs, updateWebpushSub: updateWebPushSub, deleteWebpushSub: removeWebPushSub }),
            webpushSubs.length > 0 && (React.createElement(WebPushTestWrapper, null,
                React.createElement(WebPushTestButton, { onClick: handleClickWebPushTest }, "Test Alarm"))))));
};
const NotificationMinuteForm = styled(Form) `
  width: 75px;
  box-sizing: border-box;
  margin-left: 8px;
  margin-right: 8px;
`;
const NotificationWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const GrayButton = styled(ButtonText) ``;
const WebPushTestButton = styled(ButtonText) `
  /* text-decoration: none; */
`;
const WebPushTestWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
`;
